// Components registered here are available globabally and don't have to be imported in individual components

// -- app module --

import LanguageMenu from '../modules/components/LanguageMenu'
Vue.component(LanguageMenu.name, LanguageMenu);

import Form from '../modules/form/components/Form'
Vue.component(Form.name, Form);

import ProgressBar from '../modules/components/ProgressBar'
Vue.component(ProgressBar.name, ProgressBar);


import Loader from '../modules/components/Loader.vue'
Vue.component(Loader.name, Loader);

import BackButton from '../modules/components/BackButton'
Vue.component(BackButton.name, BackButton);

import T from '../modules/components/T'
Vue.component(T.name, T);

import Message from '../modules/components/Message'
Vue.component(Message.name, Message);

import DocumentUploadField from '../modules/components/fields/DocumentUploadField'
Vue.component(DocumentUploadField.name, DocumentUploadField);

// -- plugins --

import Slim from '../assets/vendor/slim/slim';
Vue.component(Slim.name, Slim);

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import Datepicker from '../assets/vendor/vuejs-datepicker/dist/vuejs-datepicker.js';
Vue.component('datepicker', Datepicker);

import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime);

// fix for IOS not recognizing promise.finally
require('promise.prototype.finally').shim();

// -- form module --

import Field from '../modules/form/components/fields/Field'
Vue.component(Field.name, Field);

import FieldCheckbox from '../modules/form/components/fields/FieldCheckbox'
Vue.component(FieldCheckbox.name, FieldCheckbox);

import FieldCheckboxes from '../modules/form/components/fields/FieldCheckboxes'
Vue.component(FieldCheckboxes.name, FieldCheckboxes);

import FieldDate from '../modules/form/components/fields/FieldDate'
Vue.component(FieldDate.name, FieldDate);

import FieldEmail from '../modules/form/components/fields/FieldEmail'
Vue.component(FieldEmail.name, FieldEmail);

import FieldSelect from '../modules/form/components/fields/FieldSelect'
Vue.component(FieldSelect.name, FieldSelect);

import FieldRadio from '../modules/form/components/fields/FieldRadio'
Vue.component(FieldRadio.name, FieldRadio);

import FieldText from '../modules/form/components/fields/FieldText'
Vue.component(FieldText.name, FieldText);

import FieldTextarea from '../modules/form/components/fields/FieldTextarea'
Vue.component(FieldTextarea.name, FieldTextarea);







// WEBPACK FOOTER //
// ./src/utils/global-components.js